<template>
    <div class="mobile-tabs">
        <a :href="hash"
            :class="['tab', { 'is-active': isActive }]"
            v-on:click.prevent="selectTab()"
            ref="mobilelink">{{ header }}</a>
        <section v-show="isActive"
                :aria-hidden="! isActive"
                class="tabs-component-panel"
                :id="hash"
                role="tabpanel"
        >
            <slot />
        </section>
    </div>
</template>

<script>
    import helpers from '../helpers';

    export default {
        props: {
            id: { default: null },
            name: { required: true },
            prefix: { default: '' },
            suffix: { default: '' },
        },

        data: () => ({
            isActive: false,
        }),

        computed: {
            header() {
                return this.prefix + this.name + this.suffix;
            },

            hash() {
                return this.id ?
                    '#' + this.id :
                    '#' + this.name.toLowerCase().replace(/ /g, '-');
            },
        },

		watch: {
			isActive: function (val) {
				if (val && !this.$parent.firstActive) {
					var top = window.pageYOffset + this.$refs["mobilelink"].getBoundingClientRect().top;
					helpers.scrollToTop(top, 400);
                }
                this.$parent.firstActive = false;
			}
		},

        methods: {
            selectTab() {
                var close = false;
                if (this.isActive) {
                    close = true;
                }
                this.$parent.selectTab(this.hash);
                if (close) {
                    this.isActive = false;
                }
            },
        },
    };
</script>
